import React from 'react';
import {
  Alert,
  Box,
  ThemeProvider,
  Theme,
  Typography,
  createAssemblyTheme,
} from '@benchlabs/react-design-system';
import PlaidOcrUploadSection from './PlaidOcrUploadSection';
import { FeatureValue, useFeatureFlags } from '@bench/ff-client';
import { SplitFeatureFlags } from 'bk-web-app/features';
import { useQuery } from '@apollo/client';
import { useClient } from '../../ClientContext';
import { NullState } from 'bench-internal-theme';
import { WrappedSpinner } from '../../../spinner';
import { GET_LEDGER_ACCOUNTS } from '../queries';

export const PlaidOcrBpaUpload: React.FC = ({}) => {
  const client = useClient();
  const theme = React.useMemo(() => createAssemblyTheme(), []);

  const [featureState] = useFeatureFlags();
  const {
    featureContext: { features, loading: featuresLoading },
  } = featureState;

  const {
    loading,
    error,
    data: ledgerAccountData,
  } = useQuery(GET_LEDGER_ACCOUNTS, {
    variables: { clientId: client?.id },
  });

  if (error) {
    return (
      <NullState
        bigEmoji="🙈"
        title="Uh oh! An error was encountered while fetching the data for this page."
      />
    );
  }

  if (featuresLoading && loading) {
    return <WrappedSpinner />;
  }

  const ledgerAccounts = ledgerAccountData?.ledgerAccounts || [];
  const filteredLedgerAccounts = ledgerAccounts.filter(
    ledgerAccount => !!ledgerAccount.active && !!ledgerAccount.role,
  );

  const showRealTimeDataDisabledWarning =
    features[SplitFeatureFlags.BRAVEHEART_FOUNDATIONS]?.value !== FeatureValue.FEATURE_ON;

  return (
    <ThemeProvider theme={theme as Theme}>
      {showRealTimeDataDisabledWarning && (
        <Box mb={2}>
          <Alert severity="info">
            <Typography component="p" fontWeight="bold" gutterBottom>
              NOTE: This customer has Real-Time Data (Braveheart) turned off; therefore, auto
              posting is defaulted off.
            </Typography>
            <Typography component="p" gutterBottom>
              This means that if the auto post attempt didn&#39;t balance, the rec file will not be
              auto posted.
            </Typography>
            <Typography component="p" fontWeight="bold">
              Please confirm posting by checking the Reconciliation page
            </Typography>
          </Alert>
        </Box>
      )}
      <PlaidOcrUploadSection
        businessId={client?.id}
        ledgerAccounts={filteredLedgerAccounts}
        uploadedFrom="BK_TOOLS"
      />
    </ThemeProvider>
  );
};
